/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

type Props = {
  /** 割引後の価格 */
  priceJpy: number;
  /** 割引もとの価格。取り消し線付きで併記する */
  discountOriginalPrice: number;
};

// 旧価格の見た目（取り消し線）はこのコンポーネントに閉じる。
const originalPriceStyle = css({
  textDecoration: "line-through",
  marginRight: "0.5em",
  opacity: 0.6,
});

/**
 * 割引もと価格を取り消し線付きで併記し、割引後価格を表示する。
 * 割引表示を出すかどうか（割引が有効か）の判断は呼び出し側が行う。
 */
export const DiscountablePrice: React.FC<Props> = ({
  priceJpy,
  discountOriginalPrice,
}) => (
  <React.Fragment>
    {/* 旧価格であることを意味的に示す <s>。 */}
    <s css={originalPriceStyle}>¥{discountOriginalPrice.toLocaleString()}</s>¥
    {priceJpy.toLocaleString()}
  </React.Fragment>
);
